export default __webpack_public_path__ + "static/post6-2a9c6815e2b5c1c58ac7d4aae93cb94d.jpg";